import { BrowserMultiFormatReader } from '@zxing/browser';
import { useEffect, useRef } from 'react';

const QRScanner = ({ onScanSuccess }) => {
    const videoRef = useRef(null);
    const codeReaderRef = useRef(null);

    useEffect(() => {
        const codeReader = new BrowserMultiFormatReader();
        codeReaderRef.current = codeReader;

        let isMounted = true;

        codeReader
            .decodeFromVideoDevice(
                null,
                videoRef.current,
                (result, err) => {
                    if (result && isMounted) {
                        onScanSuccess(result.getText());
                    }
                }
            )
            .catch(console.error);

        return () => {
            isMounted = false;

            if (codeReaderRef.current) {
                try {
                    codeReaderRef.current.stopContinuousDecode();
                } catch (e) {
                    // ignore safely
                }
            }
        };
    }, [onScanSuccess]);

    return (
        <video
            ref={videoRef}
            style={{ width: '100%', borderRadius: '8px' }}
        />
    );
};

export default QRScanner;